module.exports = __webpack_public_path__ + "static/servicii-administrare-tehnica-large.0986f33d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/servicii/servicii-administrare-tehnica-large.jpg
// module id = 465
// module chunks = 240199439315076